var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"options-container"},[_c('currency-select'),_c('language-select'),_c('detected-country')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }